import { FC, useEffect, useState } from "react";
import useAxios from "../../../hooks/useAxios";
import { IGetPublisher } from "../../../models/publishers.model";
import useLoader from "../../../hooks/useLoader";
import { getPublisher } from "../../../api/publishers.api";
import { IStudent } from "../../../models/students.model";
import { getPublisherGradeCodes } from "../../../lib/util";
import useUtil from "../../../hooks/useUtil";
import { useTranslation } from "react-i18next";

interface IProps {
  student?: IStudent;
};

const PublisherTable: FC<IProps> = ({
  student,
}) => {
  const { t } = useTranslation();
  const { getCommonCodeLabel } = useUtil();
  const { data: res, isLoading, error, execute } = useAxios<IGetPublisher>();
  useLoader(isLoading, [error]);

  const [publisherCodes, setPublisherCodes] = useState<(string|undefined)[]>([]);

  useEffect(() => {
    if (student?.schoolCode) {
      execute(getPublisher(student.schoolCode));
    }
  }, [student]);

  useEffect(() => {
    if (student?.schoolGbn && res?.data) {
      const gradeCodes = getPublisherGradeCodes(student.schoolGbn);
      const newPublisherCodes: (string|undefined)[] = [];
      gradeCodes.forEach(gradeCode => {
        const publisher = res.data.publisherDetailResDtoList.find(item => item.gradeCode === gradeCode);
        newPublisherCodes.push(publisher?.publisherCode);
      });
      setPublisherCodes(newPublisherCodes);
    } else {
      setPublisherCodes([undefined, undefined, undefined]);
    }
  }, [student, res]);

  return (
    <>
      <div className="comm-bx__between">
        <div>
          <h4 className="sub-title">{t('student.student.52')}</h4>
        </div>
      </div>
      <div className='comm-table__area line-type'>
      <table>
        <thead>
          <tr>
            <th>{t('student.student.53')}</th>
            <th>{t('student.student.54')}</th>
            <th>{t('student.student.55')}</th>
            <th>{t('student.student.56')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>{t('student.student.21')}</th>
            <td>{getCommonCodeLabel('SY0014', publisherCodes[0]) || '-'}</td>
            <td>{getCommonCodeLabel('SY0014', publisherCodes[1]) || '-'}</td>
            <td>{getCommonCodeLabel('SY0014', publisherCodes[2]) || '-'}</td>
          </tr>
        </tbody>
      </table>
      </div>
    </>
  );
};

export default PublisherTable;